<div id="login-form">
  <div *ngIf="submitted && !validConfirmation()" class="alert alert-danger">The two passwords must be the same.</div>
  <div *ngIf="invalidToken">
    <div *ngIf="invalidToken" class="alert alert-danger" style="font-size: 13px;">The token has been already used or
      expired. Please request a new reset password link
    </div>
    <div class="login-form-actions text-center">
      <div class="login-form-actions text-center">
        <div>
          <p-button (click)="setAuthenticationServiceIsLoading(true)" label="cancel" routerLink="/"
                    styleClass="btn btn-primary btn-sm text-right"></p-button>
        </div>
      </div>
    </div>
  </div>
  <form *ngIf="!invalidToken" [formGroup]="passwordForm" class="form-horizontal">
    <div *ngIf="error">
      <div class="alert alert-danger" style="font-size: 13px;">An error occurred while processing your request.</div>
    </div>
    <div [ngClass]="{'has-error': showErrorMessage('newPassword')}" class="p-grid form-group">
      <label class="col-4 col-form-label text-right" for="newPassword">New Password</label>
      <div class="col-8 col-form-input">
        <input formControlName="newPassword" id="newPassword" pInputText type="password"/>
        <div *ngIf="submitted && !validLength()" class="show-when-error">At least 8 characters long</div>
        <div *ngIf="submitted && control.newPassword.errors && validLength() && control.newPassword.errors.required"
             class="show-when-error">Password is required
        </div>
      </div>
    </div>
    <div [ngClass]="{'has-error': showErrorMessage('newPassword')}" class="p-grid form-group">
      <label class="col-4 col-form-label text-right" for="confirmNewPassword">Confirm new password</label>
      <div class="col-8 col-form-input">
        <input formControlName="confirmNewPassword" id="confirmNewPassword" pInputText type="password"/>
        <div *ngIf="submitted && control.confirmNewPassword.errors && control.confirmNewPassword.errors.required"
             class="show-when-error">Confirm new password is required
        </div>
      </div>
    </div>
    <app-password-strength (passwordStrength)="passwordValid($event)"
                           [passwordToCheck]="passwordForm.value.newPassword"></app-password-strength>
    <div [class.alert-danger]="submitted && !passwordIsValid" class="alert alert-info">Security notice : Your password
      must be at least 8 characters long and contains at least one number and a special character.
    </div>
    <div class="login-form-actions text-center">
      <div>
        <p-button label="Submit" type="submit" styleClass="btn btn-primary btn-sm text-right" (click)="onSubmit()"></p-button>
        &nbsp; &nbsp; <a (click)="setAuthenticationServiceIsLoading(true)" routerLink="/"><i
        class="fa fa-backward alert-dark"></i> Cancel </a>
      </div>
    </div>
  </form>
</div>
